(function () {

    'use strict';

    if (typeof window === 'undefined') {
        curation(module.exports);
    } else {
        curation(RivalIQ.module('enums'));
    }

    function curation(enums) {
        enums.curation = {
            ACCOUNT: 'account',
            ACCOUNT_JOIN: 'account_join',
            ACTIVITY_OVERVIEW: 'activity_overview',
            ALERTS: 'alerts',
            ANALYZE: 'analyze',
            ANALYZE_SIMPLE: 'analyze_simple',
            COMPANIES: 'companies',
            COMPANY_ALERTS: 'company_alerts',
            COMPANY_CHANNELS: 'company_channels',
            COMPANY_SOCIALPOSTS: 'company_socialposts',
            ENGAGEMENT_OVERVIEW: 'engagement_overview',
            TWITTER_INSIGHTS: 'twitter_analytics_profile',
            TWITTER_INSIGHTS_POSTS: 'twitter_analytics_posts',
            FACEBOOK_ADS_INSIGHTS: 'facebook_ads_insights',
            FACEBOOK_INSIGHTS: 'facebook_insights',
            FACEBOOK_INSIGHTS_POSTS: 'facebook_insights_posts',
            FACEBOOK_INSIGHTS_POST_DETAILS: 'facebook_insights_post_details',
            FACEBOOK_INSIGHTS_REEL_DETAILS: 'facebook_insights_reel_details',
            INSTAGRAM_INSIGHTS: 'instagram_insights',
            INSTAGRAM_INSIGHTS_POSTS: 'instagram_insights_posts',
            INSTAGRAM_INSIGHTS_STORIES: 'instagram_insights_stories',
            INSTAGRAM_INSIGHTS_STORY_DAY: 'instagram_insights_story_day',
            CHARTS: 'charts',
            CHARTS_FAVORITES: 'charts_favorites',
            CHARTS_POSITIONING: 'charts_positioning',
            INVOICES: 'invoices',
            LANDSCAPE: 'dashboard',
            LEADERBOARD: 'leaderboard',
            LINKEDIN_INSIGHTS: 'linkedin_insights',
            LINKEDIN_INSIGHTS_POSTS: 'linkedin_insights_posts',
            POSTED_URLS: 'posted-urls',
            POSTTAGS: 'post-tags',
            POSTTAGSMANAGER: 'post-tags-manager',
            MENTIONS: 'mentions',
            MENTIONS_COMPANY_SUMMARY: 'mentions_company_summary',
            MENTIONS_MENTIONER_SUMMARY: 'mentions_mentioner_summary',
            METRICS_EXPLORER: 'metrics_explorer',
            OVERVIEW: 'overview',
            POSITIONING: 'positioning',
            DISCOVERY: 'discovery',
            REACH_OVERVIEW: 'reach_overview',
            REPORT: 'report',
            REPORTS: 'reports',
            REPORT_CENTER: 'report_center',
            SCHEDULED_REPORTS: 'scheduled_reports',
            SOCIALPOSTS: 'socialposts',
            DASHBOARDS: 'dashboards',
            DASHBOARDS_BUILDER: 'dashboards_builder',
            DASHBOARDS_PICKER: 'dashboards_picker',
            DASHBOARDS_WIDGET_EDIT: 'dashboards_widget_edit',
            DASHBOARDS_TEMPLATES: 'dashboards_templates',
            DASHBOARDS_CREATE: 'dashboards_create',
            DASHBOARDS_EMPTY: 'dashboards_empty',
            DASHBOARDS_EDIT: 'dashboards_edit',

            // React curations
            LISTENING_SEARCH: 'listening_search',
            LISTENING_SAVED_SEARCH_BUILDER: 'listening_saved_search_builder',
            LISTENING_SAVED_SEARCHES: 'listening_saved_searches',
            LISTENING_QUID_TOPICS: 'listening_quid_topics',
            LISTENING_ACCOUNT_USAGE: 'LISTENING_ACCOUNT_USAGE',
            TIKTOK_INSIGHTS: 'tiktok_insights',
            TIKTOK_INSIGHTS_VIDEOS: 'tiktok_insights_videos'
        };

        enums.configurationType = {
            PRIMARY: 'primary'
        };

        enums.visibility = {
            ACCOUNT: 1,
            LANDSCAPE: 2
        };
    }

})();
